document.addEventListener('DOMContentLoaded', function() {
  const addToCartForm = document.querySelector('[data-type="add-to-cart-form"]');
  if (addToCartForm) {
    initUpsells(addToCartForm);
    
    const qtyField = document.querySelector('.quantity__input');
    if (qtyField) initQtyUpdater(qtyField);
  } else {
    console.error('Upsells could not be initialized! Add to cart form not found.')
  }
});

function initUpsells(addToCartForm) {
  addToCartForm.addEventListener('addToCartFinished', function() {
    const selectedUpsell = document.querySelector('input[name="protection-service"]:checked');

    if (selectedUpsell) {
      const upsellId = selectedUpsell.value;

      const upsellConfig = fetchConfig('javascript');
      upsellConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete upsellConfig.headers['Content-Type'];

      const formData = new FormData();
      formData.append('quantity', selectedUpsell.dataset.qty);
      formData.append('id', upsellId);
      formData.append('sections', 'cart-notification-product,cart-notification-button,cart-icon-bubble');
      
      upsellConfig.body = formData;

      fetch(`${routes.cart_add_url}`, upsellConfig)
          .then((response) => response.json())
          .then((response) => {            
              const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

              if (cart) cart.renderContents(response);
          });
    }
  });
}

function initQtyUpdater(qtyField) {
  qtyField.addEventListener('change', function() {
    document.querySelectorAll('.upsell-price').forEach((element) => {
      const qty = !isNaN(qtyField.value) ? Math.ceil(parseInt(qtyField.value) / parseInt(element.dataset.factor)) : 1;
      const price = parseFloat(element.dataset.price) * qty / 100;

      const checkbox = element.parentNode.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.dataset.qty = qty;
      }
      
      element.innerText = Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", currencyDisplay: "code" }).format(
        price
      ).replace("EUR", "");
    });
  });
}